import React from "react";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import BlankState from "shared/components/BlankState";

import "./NoQuestionsBlankState.scss";

const NoQuestionsBlankState = () => (
	<BlankState
		id="no-questions-blank-state"
		title={_str("Whoa.")}
		description={
			_str("This doesn’t happen very often. You’ve answered all of the questions!")
		}
		buttons={(
			<a
				className="profile-questions-blank-link"
				href="/match"
			>
				<Str>Find matches</Str>
			</a>
		)}
	/>
);

export default NoQuestionsBlankState;



// WEBPACK FOOTER //
// ./src/shared/components/NoQuestionsBlankState.jsx